export enum SigninProviderType {
  GOOGLE = 'google',
  MICROSOFT = 'microsoft'
}
